import {
  setCheck,
  setTables,
  setCardForm,
  setCollapses,
  setDialogTable,
  setDialogForm,
  setPageTabs,
  setStepForm,
  setNavBar,
  setCalendars,
  setDrawerTable,
  setDeviceData
} from '@/utils/getPageInfo'
import { applyProjectDeviceTitle } from '@/utils/bidLevelActions.js'
const getters = {
  // 面包屑导航数据
  navigate: (state, getters) => {
    var navigate = {}
    if (getters['user/pages']) {
      getters['user/pages'].some((item) => {
        if (item.path === state.activePath) {
          navigate.rootpath = applyProjectDeviceTitle(item, getters['user/orgType'])
          return true
        } else if (item.children && item.children.length) {
          navigate.frompath = item.children.find((element) => {
            return element.path === state.activePath
          })
          if (navigate.frompath) {
            navigate.frompath = applyProjectDeviceTitle(
              navigate.frompath,
              getters['user/orgType']
            )
            navigate.rootpath = item
            return true
          }
        }
      })
      // 公共资料库不挂菜单：挂到「培训资料」同级面包屑下
      if (
        !navigate.rootpath &&
        state.activePath === '/workbench/publicMaterials'
      ) {
        getters['user/pages'].some((item) => {
          if (
            item.path === '/workbench/trainingMaterials' ||
            item.name === 'trainingMaterials'
          ) {
            navigate.rootpath = applyProjectDeviceTitle(
              item,
              getters['user/orgType']
            )
            return true
          }
          if (item.children && item.children.length) {
            const child = item.children.find(
              (el) =>
                el.path === '/workbench/trainingMaterials' ||
                el.name === 'trainingMaterials'
            )
            if (child) {
              navigate.rootpath = item
              navigate.frompath = applyProjectDeviceTitle(
                child,
                getters['user/orgType']
              )
              return true
            }
          }
        })
        if (!navigate.rootpath) {
          navigate.rootpath = {
            path: '/workbench/publicMaterials',
            meta: { title: '公共资料库' }
          }
        }
      }
      // 图文详情是独立路由：面包屑回到进入前的资料列表
      if (
        !navigate.rootpath &&
        state.activePath &&
        state.activePath.indexOf('/workbench/materialArticle/') === 0
      ) {
        const history = Array.isArray(state.historyStep)
          ? state.historyStep
          : []
        const prev = history[history.length - 1] || {}
        const title =
          prev.theme === 'publicMaterials'
            ? '公共资料库'
            : prev.theme === 'materialLibrary'
            ? '资料库'
            : '培训资料'
        navigate.rootpath = {
          path: prev.path || '/workbench/trainingMaterials',
          meta: { title }
        }
      }
      if (
        !navigate.rootpath &&
        (state.activePath === '/workbench/publicPapers' ||
          state.activePath === '/workbench/publicQuestions' ||
          state.activePath === '/workbench/questionImport')
      ) {
        const isPaper = state.activePath === '/workbench/publicPapers'
        const isImport = state.activePath === '/workbench/questionImport'
        const isPublicQuestions =
          state.activePath === '/workbench/publicQuestions'
        const parentPath = isImport
          ? state.questionImportFrom || '/workbench/onlineExam'
          : isPublicQuestions
          ? state.publicQuestionsFrom || '/workbench/onlineExam'
          : '/workbench/onlineExam'
        const parentName =
          parentPath === '/workbench/questionLibrary'
            ? 'questionLibrary'
            : 'onlineExam'
        const fromLibrary = parentName === 'questionLibrary'
        getters['user/pages'].some((item) => {
          if (item.path === parentPath || item.name === parentName) {
            navigate.rootpath = applyProjectDeviceTitle(
              item,
              getters['user/orgType']
            )
            return true
          }
          if (item.children && item.children.length) {
            const child = item.children.find(
              (el) => el.path === parentPath || el.name === parentName
            )
            if (child) {
              navigate.rootpath = item
              navigate.frompath = applyProjectDeviceTitle(
                child,
                getters['user/orgType']
              )
              return true
            }
          }
        })
        if (!navigate.rootpath) {
          navigate.rootpath = {
            path:
              isImport || isPublicQuestions ? parentPath : state.activePath,
            meta: {
              title:
                isImport || isPublicQuestions
                  ? fromLibrary
                    ? '试题库'
                    : '在线考试'
                  : isPaper
                  ? '公共试卷库'
                  : '公共试题库'
            }
          }
        }
      }
    } else {
      navigate.rootpath = {
        path: state.activePath,
        meta: { title: state.pageTitle }
      }
    }
    if (
      state.activePath === '/monitoring' ||
      (state.currentStep &&
        state.currentStep.theme === 'preview' &&
        state.fileType === 'pdf')
    ) {
      navigate.button = '全屏显示'
    }
    return navigate
  },
  // tab页面切换参数
  pageTabs: (state, getters) => {
    var pageTabs
    pageTabs = setPageTabs(state, getters)
    return pageTabs
  },
  // 内部导航栏组件标题名称
  navBar: (state, getters) => {
    var navBar
    navBar = setNavBar(state, getters)
    return navBar
  },
  // 查询组件渲染参数
  check: (state, getters) => {
    var check
    check = setCheck(state, getters)
    return check
  },
  // 列表组件渲染参数
  tables: (state, getters) => {
    var tables
    tables = setTables(state, getters)
    return tables
  },
  // stepForm表单渲染参数
  stepForm: (state, getters) => {
    var stepForm
    stepForm = setStepForm(state, getters)
    return stepForm
  },
  // cardForm表单渲染参数，同一页面可以有多个cardForm表单
  cardForm: (state, getters) => {
    var cardForm
    cardForm = setCardForm(state, getters)
    return cardForm
  },
  // deviceData物联设备数据展示页
  deviceData: (state, getters) => {
    var deviceData
    deviceData = setDeviceData(state, getters)
    return deviceData
  },
  // 折叠面板渲染参数，同一页面可以有多个collapses
  collapses: (state, getters) => {
    var collapses
    collapses = setCollapses(state, getters)
    return collapses
  },
  // dialogForm表单渲染参数，同一个弹窗一个表单
  dialogForm: (state, getters) => {
    var dialogForm
    void state.crowdCountTip
    dialogForm = setDialogForm(state, getters)
    return dialogForm
  },
  // dialogTable列表渲染参数，同一个弹窗一个列表
  dialogTable: (state, getters) => {
    var dialogTable
    dialogTable = setDialogTable(state, getters)
    return dialogTable
  },
  // drawerTable列表渲染参数，同一个抽屉一个列表
  drawerTable: (state, getters) => {
    var drawerTable
    drawerTable = setDrawerTable(state, getters)
    return drawerTable
  },
  // calendars日历组件渲染参数
  calendars: (state, getters) => {
    var calendars
    calendars = setCalendars(state, getters)
    return calendars
  },
  workList: (state) => {
    const workList = state.pouringOrder.unfinishedPouringOrderList
    return workList
  },
  fileUploading: (state) => {
    const map = state.fileUploadingMap
    return !!(map && Object.keys(map).length)
  }
}

export default getters
